import { Collapse } from '@mui/material';
import BetAmountInput from '../../BetAmountInput';
import styles from '../styles.module.scss';
import { GamePanelSkeletonProps } from './props';
import { Button, FormGroup, Input } from '@starsoft/common/components';

export default function GamePannelSkeleton({
  additionalSkeleton,
  bet,
  multiplier,
  nextMultiplier,
  useOnlyMobileButton,
  useSmallPadding,
}: GamePanelSkeletonProps) {
  return (
    <div
      className={`${styles.container} ${useSmallPadding ? styles['container--small-padding'] : ''}`}
    >
      <div
        className={useOnlyMobileButton ? '' : styles['container__mobile-only']}
      >
        <Button isSkeleton />
      </div>
      <BetAmountInput isLoading hasExtraButtons />
      {additionalSkeleton}
      <Collapse in={!!bet}>
        <div className={styles.container__bet__data}>
          {multiplier && (
            <FormGroup isLoading loading={{ label: true }}>
              <Input isLoading />
            </FormGroup>
          )}
          {nextMultiplier && (
            <FormGroup isLoading loading={{ label: true }}>
              <Input isLoading />
            </FormGroup>
          )}
          <FormGroup isLoading loading={{ label: true }}>
            <Input isLoading />
          </FormGroup>
        </div>
      </Collapse>
      {!useOnlyMobileButton && (
        <div className={styles['container__desktop-only']}>
          <Button isSkeleton />
        </div>
      )}
    </div>
  );
}
